//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  
  export class DeleteConceptVersionModel extends ModelBase {
      static readonly $typeName = 'DeleteConceptVersionModel';
      public name: string;
      public code: string;
      public conceptVersionKey: string;
      public codeSystemVersionKey: string;
      
  }



// WEBPACK FOOTER //
// ./src/app/vocabulary/models/DeleteConceptVersionModel.ts